/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useLayoutEffect, useEffect } from "react";
import objectPath from "object-path";
import { useLocation } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
// import { QuickActions } from "./components/QuickActions";
import { BreadCrumbs } from "./components/BreadCrumbs";
import { Dropdown } from "react-bootstrap";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { Formik, Form, Field } from "formik";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import CountrySelectInput from "../../../../app/components/SelectComponents/CountrySelectInput";
import CountrySelect from "../../../../app/muicomponents/Dropdownwithimagename1";
import CustomMultipleSelectCheckmarks from "../../../../app/muicomponents/CustomMultipleSelectCheckmarks1";
import OutlinedInput from "@mui/material/OutlinedInput";
// import { QuickUserToggler } from "../extras/QuickUserToggler";
import CompanySelectInput from "../../../../app/components/SelectComponents/CompanySelectInput";
export function NewSubHeader() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();
  const [frmInitialValues, setSearchFrmInitialValues] = useState({ q: "" });
  const [countryfrmInitialValues, setFrmInitialValues] = useState({
    country: JSON.parse(localStorage.getItem("country")),
  });
  const [error, setError] = useState(false);
  const items = ["Gamerji E-sports Private Limited.", "Vodafone idea"];
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectionChange = (selected) => {
    setSelectedItems(selected);
  };
  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderFixed: objectPath.get(uiService.config, "subheader.fixed"),
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    const isSearchOn = aside && aside.breadcrumbs.length > 0 ? true : false;
    const searchText = aside && aside.breadcrumbs.length > 0 ? null : false;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setIsSearch(isSearchOn);
    subheader.setSearchText(searchText);

    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);
  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {}, [subheader]);
  const applyFilter = (values) => {
    subheader.setSearchText(values);
  };
  const updateCountry = (value) => {};
  const signOut = (value) => {
    localStorage.clear();
    // setTimeout(() => {
    window.location.reload();
    // }, 1000);
  };
  const countries = [
    { label: "India", code: "IN", phone: "91" },
    { label: "USA", code: "US", phone: "+1" },
    { label: "Canada", code: "CA", phone: "+1" },
    // Add more countries as needed
  ];
  return (
    <div
      id="kt_subheader"
      className={`subheader py-3 py-lg-8 ${layoutProps.subheaderCssClasses}`}
    >
      <div
        className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
      >
        {/* Info */}
        <div className="d-flex align-items-center flex-wrap flex-row ">
          {/* begin::Mobile Toggle */}
          {layoutProps.subheaderMobileToggle && (
            <button
              className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}
          {/* end::Mobile Toggle */}

          {/* begin::Heading */}
          <div className="d-flex align-items-baseline mr-3">
            {/* begin::Title */}
            <h2 className="subheader-title text-dark font-weight-bold my-2 mr-2">
              {subheader.title}
            </h2>
            {/* end::Title */}

            <BreadCrumbs items={subheader.breadcrumbs} />
          </div>
          {subheader.isSearchOn && (
            <div className="d-flex align-items-baseline mr-4 min-w-200px">
              <Formik
                initialValues={frmInitialValues}
                onSubmit={(values) => {
                  applyFilter(values);
                }}
              >
                {({
                  handleSubmit,
                  handleBlur,
                  handleChange,
                  setFieldValue,
                  values,
                }) => (
                  <form
                    onSubmit={handleSubmit}
                    className="form w-100"
                    autoComplete="off"
                  >
                    <div className="d-flex w-100">
                      <div className="bg-white border col-md-12 d-flex flex-center px-6 py-2 rounded">
                        <span className="svg-icon svg-icon-lg svg-icon-primary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Search.svg"
                            )}
                          />
                        </span>
                        <input
                          type="text"
                          className="form-control border-0 font-weight-bold pl-2"
                          name="q"
                          placeholder="Search"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            setFieldValue("q", e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          )}
          {/* end::Heading */}
        </div>
        {/* Info */}

        {/* Toolbar */}
        <div className="d-flex align-items-center flex-wrap">
          {/* <button
            type="button"
            className={`btn btn-primary btn-fixed-height font-weight-bold px-2 px-lg-5 mr-2`}
          >
            <span className="svg-icon svg-icon-lg">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Add-user.svg"
                )}
              />
            </span>
            {` `}New Member
          </button> */}
          <Formik
            initialValues={countryfrmInitialValues}
            onSubmit={(values) => {
              updateCountry(values);
            }}
          >
            {({ handleSubmit, values }) => (
              <Form className="form form-label-right">
                <div className="row">
                  <div className="col">
                    <div className="form-group mb-0 min-w-100px">
                      {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Flag.svg")} /> */}
                      <CountrySelect countries={countries} error={error} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group mb-0 min-w-200px">
                      {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Flag.svg")} /> */}
                      <CustomMultipleSelectCheckmarks
                        label="Choose a Company"
                        items={items}
                        selectedItems={selectedItems}
                        onChange={handleSelectionChange}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          <Dropdown>
            <Dropdown.Toggle variant="light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {/* <Dropdown.Item href={`/${process.env.REACT_APP_PUBLIC_URL_SFIX}logout`}>Sign Out</Dropdown.Item> */}
              <Dropdown.Item onClick={() => signOut()}>Sign Out</Dropdown.Item>
              {/* <Dropdown.Item href="/my-profile">Profile</Dropdown.Item> */}
            </Dropdown.Menu>
          </Dropdown>
          {/* <QuickActions /> */}

          {/* Button */}
          {/* <button
            className="btn btn-primary btn-icon font-weight-bolds   "
            data-toggle="modal"
            data-target="#kt_chat_modal"
          >
            <span className="svg-icon svg-icon-lg">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Group-chat.svg"
                )}
              />
            </span>
          </button> */}
        </div>
      </div>
    </div>
  );
}
